import type { CustomerViewModel, TenantViewModel } from '@ail/customers-api'
import React, { Component } from 'react'
import { Column } from 'react-data-grid'
import { WithTranslation, withTranslation } from 'react-i18next'
import { ConnectedProps, connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { NavLink } from 'react-router-dom'
import { FrontendSettings } from '../../../helpers/FrontendSettings'
import IdIsCopied from '../../../helpers/IdIsCopied'
import * as customerActions from '../../../redux/actions/customerActions'
import { wrapQuery } from '../../../redux/api/apiQuery'
import { customersApi } from '../../../redux/api/customerApi'
import { State } from '../../../redux/reducers/initialState'
import { FrontendSettingsKeys } from '../../../types/enums'
import Alert from '../../common/Alert/Alert'
import Confirm from '../../common/Confirm/Confirm'
import './CompaniesAdminPanel.scss'
import ShowUnits from './showUnits/ShowUnitsFunctional'
import { Loader } from '../../common/Loader/Loader'

interface IAlertState {
  visible: boolean
  message: string
  title: string
}

interface IBreadCrumb {
  name: string
  id: string
}

interface IRouteParams {
  parent: string
  tenant?: string
}

type CompaniesAdminPanelProps = ConnectedProps<typeof connector> & WithTranslation & RouteComponentProps<IRouteParams>
interface CompaniesAdminPanelState {
  customers: CustomerViewModel[]
  copiedPopUpToggle: boolean
  idCopied: boolean
  companySearchString: string
  showGroupPopup: boolean
  searchString: string
  showUnits: boolean
  selectedCustomerId: string
  selectedTenantId: string
  selectedTenantName: string
  gridCols: Array<Column<ICustomerGridRow>>
  gridRows: ICustomerGridRow[]
  showModal: boolean
  selectedParentId: string
  breadCrumbs: IBreadCrumb[]
  deleteAlertState: IAlertState
  customerToDelete?: CustomerViewModel
  showDeleteConfirm: boolean
  showUnassignConfirm: boolean
  loading: boolean
  height: number
  tenants: TenantViewModel[]
}

interface ICustomerGridRow {
  id: string
  reference: string
  name: string
  vatNumber: string
  parentId?: string
}

class CompaniesAdminPanel extends Component<CompaniesAdminPanelProps, CompaniesAdminPanelState> {
  constructor(props: CompaniesAdminPanelProps) {
    super(props)

    const { tenant } = this.props.match.params

    if (tenant) {
      FrontendSettings.set(FrontendSettingsKeys.preselectedTenantId, tenant)
    }

    this.state = {
      customers: [],
      copiedPopUpToggle: false,
      idCopied: false,
      companySearchString: '',
      showGroupPopup: false,
      searchString: '',
      showUnits: false,
      selectedCustomerId: '',
      selectedTenantName: '',
      height: window.innerHeight,
      loading: false,
      selectedParentId: '',
      deleteAlertState: {
        message: 'nothing',
        title: 'nothing',
        visible: false,
      },
      customerToDelete: undefined,
      selectedTenantId: FrontendSettings.get(FrontendSettingsKeys.preselectedTenantId) || '',
      gridCols: [],
      gridRows: [],
      breadCrumbs: [],
      showModal: false,
      showDeleteConfirm: false,
      showUnassignConfirm: false,
      tenants: [],
    }
  }

  componentDidMount() {
    if (this.state.selectedTenantId.length === 0) {
      this.setState({
        showGroupPopup: !this.state.showGroupPopup,
      })
    }
    this.updateDimensions()

    window.addEventListener('resize', () => {
      this.updateDimensions()
    })

    this.setState({
      loading: true,
    })
    this.props.loadTenants().then((tenants) => {
      this.setState({ tenants })
      const { selectedTenantId } = this.state
      if (selectedTenantId) {
        this.props.loadCustomersAdmin(selectedTenantId).then((customers) => {
          this.setState({
            customers,
            loading: false,
          })
        })
      } else {
        this.setState({
          loading: false,
        })
      }
    })
  }

  componentDidUpdate(oldProps: CompaniesAdminPanelProps, oldState: CompaniesAdminPanelState) {
    if (this.state.idCopied !== oldState.idCopied) {
      if (this.state.idCopied) {
        setTimeout(() => {
          this.setState({
            idCopied: false,
          })
        }, 4000)
      } else {
        setTimeout(() => {
          this.setState({
            copiedPopUpToggle: false,
          })
        }, 500)
      }
    }

    if (this.props.allCustomers !== oldProps.allCustomers) {
      this.setState({
        loading: false,
      })
    }

    if (this.state.customers !== oldState.customers) {
      this.state.tenants.map((obj) => {
        if (obj.id === this.state.selectedTenantId) {
          this.setState({
            selectedTenantName: obj.name,
          })
        }
      })
    }
  }

  render() {
    const { t } = this.props
    const {
      tenants,
      showUnassignConfirm,
      customerToDelete,
      selectedTenantId,
      deleteAlertState,
      companySearchString,
      loading,
      searchString,
    } = this.state
    let groupName = ''
    if (tenants) {
      tenants.map((obj) => {
        if (obj.id === selectedTenantId) {
          groupName = obj.name
        }
      })
    }
    return (
      <>
        <Loader blocking={loading} style={{ overflow: 'hidden' }}>
          <ul className="breadcrumbs">
            <li>
              <NavLink to="/UserManagement">
                <span>{t('ADMIN_PANEL')}</span>
              </NavLink>
            </li>
            {this.state.selectedTenantName && (
              <li>
                <NavLink to={`/UserManagement/groups/`}>
                  <span>{this.state.selectedTenantName}</span>
                </NavLink>
              </li>
            )}
            <li>
              <span>{t('COMPANIES')}</span>
            </li>
            <li>
              <span></span>
            </li>
          </ul>
          <div className="row adminArea companiesArea assignOn">
            <div className="col-6 col-md-3">
              <div className="box selectArea">
                <div className="select">
                  <input
                    name={`fieldnameveryunique${new Date().getTime()}`}
                    autoComplete="none"
                    list="autocompleteOff"
                    placeholder={t('SELECT_TENANT')}
                    onClick={() => this.toggleGroupPopup()}
                    value={groupName}
                  ></input>
                  <i className="icon-bottom"></i>
                </div>
              </div>
            </div>
            <div style={{ paddingBottom: '0px', maxWidth: 'none', margin: '0' }} className="col-6 col-md-3 searchArea">
              <div style={{ maxWidth: 'none' }} className="box boxArea searchBar">
                <input
                  autoFocus={true}
                  className="filterCompanies"
                  type="search"
                  name={`fieldnameveryunique${new Date().getTime()}`}
                  autoComplete="none"
                  list="autocompleteOff"
                  onChange={(e) => this.onCompanySearchChange(e)}
                  value={companySearchString}
                  placeholder={t('FIND_CUSTOMER_BY_KEYWORD')}
                />
                {!!this.state.companySearchString && (
                  <i className="icon-clear" onClick={() => this.setState({ companySearchString: '' })} />
                )}
                <i className="icon-search"></i>
              </div>
            </div>
            <div className="itemList">
              {this.state.selectedTenantId &&
                this.state.customers.map(
                  (obj, i) =>
                    obj.name.toLowerCase().indexOf(companySearchString.toLowerCase()) > -1 && (
                      <div key={i} className="col-6 col-md-3">
                        <div className="box groupArea">
                          <div className="control-group checkbox">
                            <div className="row">
                              <label className="control control-checkbox">
                                <input type="checkbox" checked />
                                <div className="control_indicator"></div>
                              </label>
                            </div>
                          </div>
                          <div className="flex companyTitle">
                            <div
                              className="itemTitle"
                              style={
                                this.props.currentUser?.isAdmin ||
                                (this.props.currentUser?.isInternalUser && this.props.currentUser?.isManager)
                                  ? undefined
                                  : { width: '100%' }
                              }
                            >
                              {obj.name}
                            </div>
                            {(this.props.currentUser?.isAdmin ||
                              (this.props.currentUser?.isInternalUser && this.props.currentUser?.isManager)) && (
                              <div className="multiComp" onClick={() => this.onUnassign(obj.id)}>
                                <i className="icon-unassign"></i>
                              </div>
                            )}
                          </div>
                          <div className="flex">
                            <div className="itemAction infoComp">
                              <i className="icon-assign"></i>
                              <strong>
                                {this.props.allCustomers?.filter((el) => obj.parentId === el.id)[0]?.name ||
                                  this.state.selectedTenantName}
                              </strong>
                            </div>
                            <div className="itemAction infoComp">
                              <i
                                style={this.props.currentUser?.isAdmin ? { cursor: 'pointer' } : undefined}
                                onClick={() => this.copyCompanyID(obj.id)}
                                className="icon-id"
                              ></i>
                              {obj.reference}
                            </div>
                            <div className="itemAction infoComp">
                              <i className="icon-vat"></i>
                              {obj.vatNumber}
                            </div>
                            <div className="itemAction infoComp">
                              <i className="icon-marker"></i>
                              {obj.primary?.addresses != null && obj.primary?.addresses.length > 0 && (
                                <span>
                                  {obj.primary?.addresses[0]?.state ?? ''}
                                  {obj.primary?.addresses[0]?.city ?? ''}
                                  {obj.primary?.addresses[0]?.postalCode ?? ''}
                                  {obj.primary?.addresses[0]?.street ?? ''}
                                </span>
                              )}
                            </div>
                            <div className="itemAction">
                              <div className="action" onClick={() => this.showUnits(obj.id)}>
                                <div className="table-cell">
                                  <i className="icon-units"></i>
                                  {t('UNITS')}
                                </div>
                              </div>
                            </div>
                            <div className="itemAction">
                              <a onClick={() => this.moveToUsersWithCompany(obj.id)} className="action">
                                <div className="table-cell">
                                  <i className="icon-users"></i>
                                  {t('USERS')}
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                )}
            </div>
          </div>
          {this.state.showGroupPopup && !this.state.loading && (
            <>
              <div className="popGroupSelect">
                <a onClick={() => this.toggleGroupPopup()} className="closeBtn">
                  <i className="icon-close"></i>
                </a>
                <div className="itemTitle">
                  <label className="leftItemTitle">{t('SELECT_TENANT')}</label>
                </div>
                <div className="centerInput">
                  <input
                    name={`fieldnameveryunique${new Date().getTime()}`}
                    autoComplete="none"
                    list="autocompleteOff"
                    placeholder={t('TENANT_NAME')}
                    onChange={(e) => this.onSearchChange(e)}
                  ></input>
                  {searchString.length >= 2 && (
                    <ul>
                      {tenants.map(
                        (obj, i) =>
                          obj.name.toLowerCase().indexOf(searchString.toLowerCase()) > -1 && (
                            <li key={i} onClick={() => this.onTenantChanged(obj)}>
                              {obj.name}
                            </li>
                          )
                      )}
                    </ul>
                  )}
                </div>
              </div>
              <div className="blur"></div>
            </>
          )}
        </Loader>
        {this.state.copiedPopUpToggle && <IdIsCopied idCopied={this.state.idCopied} />}
        <Confirm
          visible={showUnassignConfirm}
          onClose={(confirm: boolean) => {
            this.handleUnassignConfirmClose(confirm)
          }}
          title={t('PLEASE_CONFIRM')}
          message={`${t('DO_YOU_WANT_TO_UNASSIGN')} ${customerToDelete?.name} ${t('FROM')} ${
            tenants.find((te) => te.id === selectedTenantId)?.name
          }?`}
        />
        <Alert
          onClose={() => {
            this.toggleAlert()
          }}
          visible={deleteAlertState.visible}
          title={deleteAlertState.title}
          message={deleteAlertState.message}
        />
        {this.state.showUnits && (
          <ShowUnits
            tenantId={this.state.selectedTenantId}
            customerId={this.state.selectedCustomerId}
            onClose={() => this.toggleUnitsGrid()}
          />
        )}
      </>
    )
  }

  private copyCompanyID(e: string) {
    if (!this.props.currentUser?.isAdmin) {
      return
    }
    navigator.clipboard.writeText(e)
    this.setState({
      idCopied: true,
      copiedPopUpToggle: true,
    })
  }

  private moveToUsersWithCompany(id: string) {
    FrontendSettings.set(FrontendSettingsKeys.companyIdInUsersFilter, id)
    this.props.history.push(`/UserManagement/users`)
  }

  private onSearchChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { value } = e.target
    this.setState({
      searchString: value,
    })
  }

  private toggleGroupPopup() {
    this.setState({
      showGroupPopup: !this.state.showGroupPopup,
    })
  }

  private onCompanySearchChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { value } = e.target
    this.setState({
      companySearchString: value,
    })
  }

  private showUnits(customerId: string) {
    this.setState({
      showUnits: true,
      selectedCustomerId: customerId,
    })
  }

  private updateDimensions() {
    const c = 210
    const height = window.innerHeight > c ? window.innerHeight - c : window.innerHeight
    this.setState({
      height,
    })
  }

  private toggleUnitsGrid() {
    this.setState({
      showUnits: !this.state.showUnits,
    })
  }

  private toggleAlert(message?: string, title?: string) {
    const deleteAlertState: IAlertState = {
      ...this.state.deleteAlertState,
      visible: !this.state.deleteAlertState.visible,
    }

    if (message) {
      deleteAlertState.message = message
    }

    if (title) {
      deleteAlertState.title = title
    }

    this.setState({
      deleteAlertState,
    })
  }

  private handleUnassignConfirmClose(confirm: boolean) {
    const { selectedTenantId, customerToDelete } = this.state
    const { t } = this.props

    if (confirm) {
      if (customerToDelete?.id) {
        this.setState({
          loading: true,
        })

        this.props.patchUnassignedRootCustomerTenant(customerToDelete.id, undefined).then(
          () => {
            this.props.loadCustomersAdmin(selectedTenantId).then((customers) => {
              this.setState({ customers })
              this.props.loadAllCustomers()
            })
          },
          () => {
            this.setState({
              loading: false,
            })
            this.toggleAlert(t('ITEM_UNASSIGN_FAILED'), t('CONFLICT'))
          }
        )
      }
    }
    this.toggleUnassignConfirm()
  }

  private toggleUnassignConfirm() {
    this.setState({
      showUnassignConfirm: !this.state.showUnassignConfirm,
    })
  }

  private onTenantChanged(e: TenantViewModel) {
    const selectedTenantId = e.id
    if (!selectedTenantId) {
      this.setState({
        selectedTenantId: this.state.selectedTenantId,
      })

      return
    }

    FrontendSettings.set(FrontendSettingsKeys.preselectedTenantId, selectedTenantId)
    this.setState({
      showGroupPopup: !this.state.showGroupPopup,
      searchString: '',
      loading: true,
      selectedTenantId,
    })

    this.props.loadCustomersAdmin(selectedTenantId).then((customers) => {
      this.setState({
        customers,
        loading: false,
      })
    })
  }

  private toggleModal() {
    this.setState({
      showModal: !this.state.showModal,
    })
  }

  private onUnassign(customerId: string) {
    this.setState({
      customerToDelete: this.state.customers.find((c) => c.id === customerId),
      showUnassignConfirm: true,
    })
  }
}

/**
 * decide what part of state should be exposed
 * @param state  redux state
 * @param ownProps props of component
 */
function mapStateToProps({ appData, customers }: State) {
  return {
    currentUser: appData.currentUser,
    allCustomers: customers.customers,
  }
}

/**
 * What action should be passed to component
 */
const mapDispatchToProps = {
  loadTenants: wrapQuery(() => customersApi.endpoints.getTenants.initiate()),
  loadCustomersAdmin: wrapQuery((tenantId: string) => customersApi.endpoints.getCustomers.initiate(tenantId)),
  patchUnassignedRootCustomerTenant: wrapQuery((customerId: string, tenantId?: string) =>
    customersApi.endpoints.patchCustomerTenant.initiate({ customerId, tenantId })
  ),
  loadAllCustomers: customerActions.loadAllCustomers,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

// eslint-disable-next-line react-refresh/only-export-components
export default connector(withTranslation('common')(withRouter(CompaniesAdminPanel)))
